import { siteCall } from "../../src/utils/WebCall";
import urls from '../../src/utils/urls'
import { getCurrentUser, partialUpdateUser, getUser, NewUserModel, fetchUserData } from './UserService';
import {
  getAdditionalUserInfo
} from "firebase/auth";
import { signInWithPopup } from "firebase/auth";

export const login = (email, password, successCallback, errorCallback) => {
    return siteCall({
        url: urls.signin_url,
        method: "POST",
        body: JSON.stringify({
          email: email,
          password: password
        }),
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
}

export const signup = (email, password, userName, configs) => {
  const {
    toast,
    isCheckboxChecked,
    setLoading,
    setEmailVal,
    setUserNameVal,
    setPasswordVal,
    setCheckboxVal,
    setSamePassword,
    setPasswordLengthVal,
    dispatch,
    navigate,
    setNewUser
  } = configs;

  let isError = false;
  if(email == ""){
    setEmailVal(true);
    isError = true;
  }
  if(userName == ""){
    setUserNameVal(true);
    isError = true;
  }
  if(password == ""){
    setPasswordVal(true);
    isError = true;
  }
  if(!isCheckboxChecked){
    setCheckboxVal(true);
    isError = true;
  }
  if (userName === password) {
    setSamePassword(true);
    isError = true;
  }
  if(password.length <= 5){
    setPasswordLengthVal(true);
    isError = true;
  }
  if(isError == true){
    setLoading(false);
    return false;
  }

  return siteCall({
      url: urls.signup_url,
      method: "POST",
      body: JSON.stringify({
        email: email,
        password: password,
        displayName: userName,
      }),
      successCallback: (response) => {
        dispatch(setNewUser(true));
        // Navigate to the login page
        let response_data = response.data;
        window.dataLayer.push({
          'event' : 'login',
          'userId' : response_data.localId //this number must be replaced with an actual User ID
        })
        navigate("/login");
        setLoading(false);
      },
      errorCallback: (error) => {
        toast.error("User already exists. Please login");
        setLoading(false);
      },
    });
}


export const getIdTokenUsingRefreshToken = (refresh_token, successCallback, errorCallback) => {
  return siteCall({
      url: urls.get_id_token_url,
      method: "POST",
      body: JSON.stringify({
        refresh_token: refresh_token
      }),
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const checkAuthenticatedUser = async(props) => {
  const { navigate, dispatch } = props;
  let user = getCurrentUser();
  return fetchUserData(dispatch).then(
    (response) => {
      let data = response;
      console.log("User authenticated: ", data)
      return true;
    })
    .catch((error) => {
      let refreshToken = user.refreshToken;
      if(refreshToken){
        return getIdTokenUsingRefreshToken(refreshToken,
          (response) => {
            let data = response.data;
            let idToken = data.idToken;
            let refreshToken = data.refreshToken;

            localStorage.setItem("idToken", idToken);
            localStorage.setItem("refreshToken", refreshToken);
            window.location.reload();
            return true;
          },
          (error) => {
            navigate("/signup")
            return false;
          }
        )
      }else{
        navigate("/signup")
        return false;
      }
    }
  )
}


const handleLoginWithGoogle = async (props, result) => {
  const { dispatch, setNewUser, navigate } = props;
  const user = result.user;
  const additionalUserInfo = getAdditionalUserInfo(result);
  const isNewUserFromAuthResult = additionalUserInfo.isNewUser;
  console.log("newUser:", isNewUserFromAuthResult)
  dispatch(setNewUser(isNewUserFromAuthResult));

  let idToken = result._tokenResponse.idToken;
  let refreshToken = result._tokenResponse.refreshToken;
  let expiresIn = result._tokenResponse.expiresIn;
  localStorage.setItem("@auth", user.uid);
  localStorage.setItem("uid", user.uid);
  localStorage.setItem("idToken", idToken)
  localStorage.setItem("refreshToken", refreshToken)
  
  if (isNewUserFromAuthResult) {
    const data = await siteCall({
      url: urls.social_signup_url,
      method: "POST",
      body: JSON.stringify({
        email: user.email,
        profile: additionalUserInfo?.profile?.picture,
        displayName: user.displayName,
      }),
      successCallback: (response) => {
        window.dataLayer.push({
          'event' : 'login',
          'userId' : user.uid //this number must be replaced with an actual User ID
        })
        return response.data;
      },
      errorCallback: (error) => {
      },
    });
  }else{
    let userArray = { lastAccessAt: new Date() };
    await partialUpdateUser(user.uid, userArray);
  }

  navigate("/");
  // getUser(user.uid,
  //     async(response) => {
  //       let data = response.data || {};

  //       let userArray = { lastAccessAt: new Date() };
  //       if (isNewUserFromAuthResult || Object.keys(data).length == 0) {
  //         console.log("New user signed up!", user);
  //         const newUserModel = NewUserModel({})
  //         userArray = { 
  //           email: user.email,
  //           name: user.displayName,
  //           createdAt: new Date(),
  //           isNewUser: true,
  //           profile: additionalUserInfo?.profile?.picture,
  //           ...newUserModel
  //         }
  //       }
  //       await partialUpdateUser(user.uid, userArray);
  //       navigate("/");
  //     }
  // )
};

export const loginWithGoogle = async (props) => {
  const { auth, provider } = props;
  signInWithPopup(auth, provider)
    .then((result) => {
      handleLoginWithGoogle(props, result);
    })
    .catch((error) => {
      console.log(error, "error");
    });
};